import { formatDateToPTBR } from '../features/new-os/utils/formatters';

/** Aviso informativo: vencimento já passou ou está em até 30 dias (TB02111_VENCCONTR). */
export const CONTRACT_WARN_WITHIN_DAYS = 30;

/**
 * @param {string|Date|null|undefined} contrVenc
 * @returns {{ dateLabel: string, expired: boolean, daysLeft: number } | null}
 */
export function getContractExpiryWarning(contrVenc) {
  if (!contrVenc) return null;
  const vencDate = new Date(contrVenc);
  if (Number.isNaN(vencDate.getTime())) return null;
  vencDate.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const daysLeft = Math.round((vencDate.getTime() - today.getTime()) / 86400000);
  if (daysLeft > CONTRACT_WARN_WITHIN_DAYS) return null;
  let dateLabel = '';
  try {
    dateLabel = formatDateToPTBR(vencDate) || '';
  } catch {
    dateLabel = '';
  }
  if (!dateLabel) return null;
  return {
    dateLabel,
    expired: daysLeft < 0,
    daysLeft,
  };
}

/**
 * Entre vários avisos, prioriza o mais vencido; senão o que vence mais cedo.
 * @param {Array<{ dateLabel: string, expired: boolean, daysLeft: number }>} warnings
 */
export function pickWorstContractExpiryWarning(warnings) {
  const list = (warnings || []).filter(Boolean);
  if (!list.length) return null;
  const expired = list.filter((w) => w.expired).sort((a, b) => a.daysLeft - b.daysLeft);
  if (expired.length) return expired[0];
  return list.slice().sort((a, b) => a.daysLeft - b.daysLeft)[0];
}
